
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society-profile/edit",
      function () {
        return require("private-next-pages/society-profile/edit.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society-profile/edit"])
      });
    }
  